import { render } from "./MaterialsScanners.vue?vue&type=template&id=8b1e0174"
import script from "./MaterialsScanners.vue?vue&type=script&lang=js"
export * from "./MaterialsScanners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__